import { render } from "./ThePriceManual.vue?vue&type=template&id=67b23ca4"
import script from "./ThePriceManual.vue?vue&type=script&lang=js"
export * from "./ThePriceManual.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__